import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-newsdetails',
  templateUrl: './newsdetails.component.html',
  styleUrls: ['./newsdetails.component.css']
})
export class NewsdetailsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
